import { UserAvatar } from '../../auth/UserAvatar.tsx'
import { SearchBar } from '@/search/components/SearchBar'

export function AppHeader() {
  return (
    <>
      <div className="appHeader">
        <div className="appHeader-side" />
        <SearchBar />
        <div className="appHeader-side appHeader-side--right">
          <UserAvatar />
        </div>
      </div>
    </>
  )
}
